// extracted by mini-css-extract-plugin
export var statItem = "_du-1";
export var statsRow = "_du-0";